import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../theme'
import { color } from 'chart.js/types/helpers'

const selectFromFileStyles: IStyles = {
    selectedDevicesFromFile: {
        overflow: 'hidden',
    },
    selectedDevicesFromFileCondition: {
        marginBottom: 6,
    },
    selectedDevicesFromFileOpenModal: {
        marginTop: 14,
        textDecoration: 'underline',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    modal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
    },
    close: {
        position: 'absolute',
        top: 30,
        right: 30,
    },
    modalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: colors.white,
        borderRadius: 19,
        width: '70%',
        height: '90vh',
        overflow: 'hidden',
        padding: 30,
    },
    modalTabs: {
        marginTop: 24,
        marginBottom: 30,
    },
    modalInfo: {
        height: '72vh',
        overflow: 'auto',
    },
    scroll: {
        maxHeight: '100%',
        height: '100%',
        width: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',

        td: {
            borderBottom: '1px solid black',
            padding: '4px 4px',

            '&:first-child': {
                maxWidth: 50,
            },
        },
    },
    tableHeader: {
        td: {
            paddingBottom: '10px !important',
        },
    },
    emptyList: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    cancelBtn: {
        margin: '24px auto',
    },
}

addStyles(selectFromFileStyles)
export default selectFromFileStyles
